
import './index.less'
import React from 'react'
console.log(React)
export default function NavItemCopy(props) {
  return (<div className='navItemCopy'>
    <i className='navItemCopy_icon'>{props.ifon.icon}</i>
    <span className='navItemCopy_copy'>{props.ifon.text}</span>
  </div>)
}
